<template>
  <div :class="['session-studio-container', 'not-admin', { 'multi-members': hasPartners(member) }]">
    <SessionL :fit20="fit20" :member="member" :selectedMember="selectedMember" :updateLastWeight="updateLastWeight"
      :lastWeight="lastWeight" :tabNum="tabNum" :newRemarks="newRemarks" :newRemarkValue="newRemarkValue"
      :isRemarksChanged="isRemarksChanged" :formatDate="formatDate" :isChanged="isChanged"
      :capitalizeFirstLetter="capitalizeFirstLetter" :originalMember="originalMember" :socket="socket"
      :selectedMachine="selectedMachine" :machineSetting="machineSetting" :repCount="repCount"
      :secondCount="secondCount" :showStationary="showStationary" :saveMemberMachineSetting="saveMemberMachineSetting"
      :stationaryCounter="stationaryCounter" :QS="QS" :personalBest="personalBest" :overAllQs="overAllQs" :msg="msg"
      :trainingAge="trainingAge" :selectTab="selectTab" :closeWebSocket="closeWebSocket" :youBarWidth="youBarWidth"
      :youBarBgColor="youBarBgColor" :followMeBarWidth="followMeBarWidth">
    </SessionL>

    <SessionM :fit20="fit20" :member="member" :selectedMember="selectedMember" :tabNum="tabNum" :sessions="sessions"
      :formatDate="formatDate" :showEditMachineSetting="showEditMachineSetting" :originalMember="originalMember"
      :activeSession="activeSession" :newSession="newSession" :displayedSessions="displayedSessions"
      :editSessionRemark="editSessionRemark" :selectedMachine="selectedMachine" :machineSetting="machineSetting"
      :executeMachine="executeMachine" :isDropdownOpenIndex="isDropdownOpenIndex" :isChanged="isChanged"
      :setMachineExecute="setMachineExecute" :editMachineSetting="editMachineSetting"
      :saveMemberMachineSetting="saveMemberMachineSetting" :hasPartners="hasPartners" :editSession="editSession"
      :selectMachine="selectMachine" :togglePopup="togglePopup" :setAbsent="setAbsent"
      :showAbsentPopup="showAbsentPopup" :showAbsentOption="showAbsentOption" :makeMemberAbsent="makeMemberAbsent"
      :saveMemberAbsent="saveMemberAbsent" :absentError="absentError" :oldMachineUnselected="oldMachineUnselected"
      :displayAllSessions="displayAllSessions" :exerciseStarted="exerciseStarted" :machinesRemarks="machinesRemarks">
    </SessionM>

    <SessionR :fit20="fit20" :member="member" :activeSession="activeSession" :newSession="newSession"
      :selectedMachine="selectedMachine" :executeMachine="executeMachine" :machineSetting="machineSetting"
      :isDropdownOpenIndex="isDropdownOpenIndex" :machinesRemarks="machinesRemarks" :selectedExercise="selectedExercise"
      :setMachineExecute="setMachineExecute" :editMachineSetting="editMachineSetting"
      :changeExerciseWeight="changeExerciseWeight" :exerciseStarted="exerciseStarted" :showStartBtn="showStartBtn"
      :showStartBtnPopup="showStartBtnPopup" :stopExercise="stopExercise" :exerciseStopped="exerciseStopped"
      :unselectExercise="unselectExercise" :isExerciseSelected="isExerciseSelected" :tabNum="tabNum"
      :lastExercise="lastExercise" :editTimePopup="editTimePopup" :saveTime="saveTime" :setMin="setMin" :setSec="setSec"
      :repCount="repCount" :setLastExercise="setLastExercise" :showStationary="showStationary" :stationary="stationary"
      :isWeightDropdownOpen="isWeightDropdownOpen" :exerciseChangeValues="exerciseChangeValues"
      :unselectMachine="unselectMachine" :showCountDown="showCountDown">
    </SessionR>

    <div class="popup-countDown" v-if="showCountDown">
      <div>
        <div>
          <div class="countDown animated zoomIn">
            {{ countDown }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qs, getBestScore, getOverAllQs, computeQualityScores, getWeights } from "../actions/qs.js";
import { randomMsg, getTrainingAge, formattedDateTime } from "../actions/global.js"
import isEqual from 'lodash/isEqual';
import SessionL from "./SessionL.vue";
import SessionM from "./SessionM.vue";
import SessionR from "./SessionR.vue";

export default {
  name: 'Session',
  components: {
    SessionL,
    SessionM,
    SessionR
  },
  props: ["fit20", "admin", "selectTab", "admin_fit20", "formatDate", "member", 'tabNum'],
  data() {
    return {
      startTime: "",
      youBarWidth: '0%',
      followMeBarWidth: '0%',
      youBarBgColor: '#92D400',
      closeWebSocketTimeout: false,
      secondCount: 0,
      trainingAge: '',
      msg: '',
      overAllQs: 0,
      oldMachineUnselected: '',
      personalBest: {
        allWeights: '',
        thisWeight: '',
        last5Session: ''
      },
      QS: false,
      showStationary: false,
      stationaryCounter: 11,
      stationaryInterval: '',
      repCount: 0,
      lastExercise: false,
      sensorData: [],
      socket: false,
      absentError: false,
      showAbsentPopup: false,
      showAbsentOption: false,
      min: undefined,
      sec: undefined,
      editTimePopup: false,
      isExerciseSelected: false,
      showStartBtnPopup: false,
      exerciseStarted: false,
      exerciseStopped: false,
      isWeightDropdownOpen: false,
      exerciseChangeValues: ['MORE', 'LESS', 'SAME', ''],
      defaultSession: {},
      machinesRemarks: {},
      newExerciseRemark: '',
      newSessionRemark: '',
      activeSession: false,
      isDropdownOpenIndex: -1,
      machineSetting: {},
      executeMachine: {},
      showEditMachineSetting: false,
      selectedMachine: false,
      sessions: [],
      newSession: {},
      displayedSessions: [],
      newRemarks: '',
      newRemarkValue: '',
      isRemarksChanged: false,
      alreadyOpened: false,
      counter: -4,
      showCountDown: false,
      countDown: 4,
      selectedMember: '',
      isChanged: false,
      originalMember: '',
      lastWeight: 0,
      newWeight: {
        date: new Date(),
        weight: 0,
      },
      selectedExercise: {},
      exerciseIntervalId: '',
      prMsg: false,
    };
  },
  methods: {
    getCorrectLang: function () {
      let lang = 'en'
      if (this.selectedMember && this.selectedMember.language.length > 0) {
        lang = this.selectedMember.language;
      } else if (this.fit20.studio.language && this.fit20.studio.language.length > 0) {
        lang = this.fit20.studio.language;
      }
      return lang;
    },
    updateLastWeight: function (lastWeigh) {
      this.lastWeight = lastWeigh;
    },
    setLastExercise: function () {
      this.lastExercise = !this.lastExercise;
    },
    mapValueToPercentage: function (value, minInput, maxInput, minOutput, maxOutput) {
      // Clamp the value within the input range
      value = Math.min(Math.max(value, minInput), maxInput);

      // Calculate the percentage using linear interpolation
      const percentage = ((value - minInput) / (maxInput - minInput)) * (maxOutput - minOutput) + minOutput;

      return percentage;
    },
    setAbsent: function (open) {
      if (open) {
        this.showAbsentPopup = true;
        if (this.newSession.absent) {
          this.showAbsentOption = true;
        } else {
          this.showAbsentOption = false;
        }
        this.absentError = false;
      } else {
        this.showAbsentPopup = false;
        this.newSession.absentReason = '';
        this.showAbsentOption = false;
      }
    },
    makeMemberAbsent(e) {
      if (e.target.checked) {
        this.showAbsentOption = true;
      } else {
        this.showAbsentOption = false;
      }

    },
    saveMemberAbsent() {
      if (this.showAbsentOption && this.newSession.absentReason.length < 2) {
        // alert !!!!!!!!! please choose a reason
        this.absentError = true;
      }
      if (this.showAbsentOption && this.newSession.absentReason.length > 2) {
        this.showAbsentPopup = false;
        this.newSession.absent = true;
      }
      if (!this.showAbsentOption) {
        this.newSession.absentReason = '';
        //  this.showAbsentOption = false;
        this.showAbsentPopup = false;
        this.newSession.absent = false;
      }

    },
    setMin: function (e) {
      this.min = e.target.value * 60;
    },
    setSec: function (e) {
      this.sec = e.target.value;
    },
    secondsToTime: function (seconds) {
      let minutes = Math.floor(seconds / 60);
      let remainingSeconds = seconds % 60;

      // Use template literals to format the time
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    },
    saveTime: function (save) {
      let duration = this.secondsToTime(this.selectedExercise.duration);
      let duration1 = duration.split(':')[0] ? Number(duration.split(':')[0]) : 0;
      let duration2 = duration.split(':')[1] ? Number(duration.split(':')[1]) : 0;
      if (save) {
        let min = Number(this.min) >= 0 ? Number(this.min) : duration1 ? duration1 * 60 : 0;
        let sec = Number(this.sec) >= 0 ? Number(this.sec) : duration2 ? duration2 : 0;
        this.selectedExercise.duration = Number(min) + Number(sec);
      }
      this.min = undefined;
      this.sec = undefined;
      this.editTimePopup = false;
    },
    stationary: async function () {
      if (this.socket) {
        this.stationaryCounter = 11;
        // send req to msa
        let machineInStudio = false;
        if (this.selectedMachine.id) {
          machineInStudio = this.fit20.studio.machines.find(machine => machine.id == this.selectedMachine.id || this.selectedMachine.id == '1001' && machine.id == this.fit20.newLegPress);
        }
        if (machineInStudio) {
          try {
            await fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/exercise/stationary`);
            this.startStationaryCounter();
            this.showStationary = true;
            if (this.stationaryInterval) {
              clearInterval(this.stationaryInterval);
            }
            this.stationaryInterval = setInterval(() => this.startStationaryCounter(), 1000);
          }
          catch (err) {
            console.log({ err });
            this.fit20.errors.push("Error in stationary in Session.vue " + formattedDateTime());
            this.fit20.errors.push(JSON.stringify({
              message: err.message,
              stack: err.stack,
              name: err.name,
            }) + " " + formattedDateTime());
            this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('Network error!') });
          }
        }
      }
    },
    areDatesInDifferentMonths(date1, date2) {
      const dateObj1 = new Date(date1);
      const dateObj2 = new Date(date2);
      const year1 = dateObj1.getUTCFullYear();
      const month1 = dateObj1.getUTCMonth(); // Note: getUTCMonth() returns a zero-based month (0 for January, 1 for February, etc.)
      const year2 = dateObj2.getUTCFullYear();
      const month2 = dateObj2.getUTCMonth();

      return year1 !== year2 || month1 !== month2;
    },
    getFirstSessionPerMonth: function (sessions) {
      const grouped = {};
      sessions.slice().reverse().forEach(session => {
        const date = new Date(session.date);
        const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`; // YYYY-MM
        if (!grouped[monthKey]) {
          grouped[monthKey] = session;
        }
      });
      return Object.values(grouped);
    },

    editSessionRemark: function (e) {
      this.newSessionRemark = e.target.value;
    },
    stopExercise: async function () {
      // this.$root.$emit('close-cali-popup' + this.selectedMember.id);
      this.showStationary = false;
      let oldMachineInStudio = false;
      if (this.stationaryInterval) {
        clearInterval(this.stationaryInterval);
        this.stationaryInterval = "";
      }
      if (this.selectedMachine.id) {
        oldMachineInStudio = this.fit20.studio.machines.find(machine => machine.id == this.selectedMachine.id || this.selectedMachine.id == '1001' && machine.id == this.fit20.newLegPress);
      }
      await this.closeWebSocket(oldMachineInStudio, true);
      clearInterval(this.exerciseIntervalId);
      this.exerciseStarted = false;
      this.exerciseStopped = true;
      this.repCount = 0;
      this.secondCount = 0;
      if (this.selectedExercise.order == '-') {
        this.selectedExercise.order = this.newSession && this.newSession.exercises && this.newSession.exercises.length ? this.newSession.exercises.length : "?";
      }
      this.fit20.saveSessionControl['tab' + (this.tabNum + 2)].shift();

      // start qs
      if (this.sensorData && this.sensorData.length > 20 && this.counter > 30) {
        let bestScore = "";
        this.fit20.errors.push("sensor data length for" + this.selectedMember.displayFirstName + " on " + this.selectedMachine.name + " : " + this.sensorData.length + " " + formattedDateTime());
        this.fit20.errors.push("First sensor data for:" + this.selectedMember.displayFirstName + " on " + this.selectedMachine.name + " " + JSON.stringify(this.sensorData[0]) + " " + formattedDateTime());
        let QS = computeQualityScores(this.sensorData, this.selectedMachine.name);
        this.selectedExercise.qs_average = QS.average;
        this.selectedExercise.qs_range = QS.range;
        this.selectedExercise.qs_rhythm = QS.rhythm;
        this.selectedExercise.qs_tempo = QS.tempo;
        this.QS = QS;
        this.fit20.errors.push("QS for " + this.selectedMember.displayFirstName + " on " + this.selectedMachine.name + ": " + JSON.stringify({ average: this.QS.average, tempo: this.QS.tempo, rhythm: this.QS.rhythm, range: this.QS.range }) + " " + formattedDateTime());
        if (this.sessions.length > 4) {
          bestScore = getBestScore(QS, this.sessions, this.selectedMachine.id);
        }
        this.personalBest = {
          allWeights: getWeights(QS, this.sessions, this.selectedMachine.id),
          thisWeight: getWeights(QS, this.sessions, this.selectedMachine.id, { weight: this.selectedExercise.weight }),
          last5Session: getWeights(QS, this.sessions, this.selectedMachine.id, { last5: true }),
        }
        let overAllQS = 0;
        if (this.lastExercise) {
          overAllQS = getOverAllQs(this.newSession.exercises, this.lastExercise);
          if (overAllQS != 0) {
            this.newSession.training_age.overall_qs = overAllQS;
            this.overAllQs = overAllQS
          }
        }

        let msg = randomMsg(bestScore, this.selectedExercise.order, this.prMsg, this.fit20.motivationMsg);
        if (!this.prMsg && msg.length > 1) {
          this.prMsg = msg;
        }
        // this.msg = msg && !this.$t(msg, this.getCorrectLang()).includes('M80') ? this.$t(msg, this.getCorrectLang()) : '';
        const translatedMsg = msg ? this.$t(msg, this.getCorrectLang()) : '';
        this.msg = translatedMsg && !translatedMsg.includes('M80') ? translatedMsg : '';
        // console.log(this.sessions[0].date,);
        // <<<< calc the training age in the last exercise >>>>
        // if (this.lastExercise &&
        //   this.selectedMember.gender.includes("male") &&
        //   this.newSession.exercises.length >= 4 &&
        //   this.sessions.length >= this.fit20.minSessionsNeeded &&
        //   this.areDatesInDifferentMonths(this.sessions[0].date, this.newSession.date)) {
        //   console.log('Start training age for first session in the month >>>>>>>>>>>>> ');
        //   let last3ValidSessions = [];
        //   for (const session of this.sessions) {
        //     if (!session.absent &&
        //       session.exercises.length >= 4 &&
        //       this.areDatesInDifferentMonths(session.date, this.newSession.date)) {
        //       last3ValidSessions.push(session);
        //       if (last3ValidSessions.length === 3) break; // Stop once we have 3 matches
        //     }
        //   }
        //   console.log({ last3ValidSessions: last3ValidSessions.length });
        //   console.log(last3ValidSessions);
        //   if (last3ValidSessions && last3ValidSessions.length == 3) {
        //     console.log('call getTrainingAge');
        //     this.newSession.training_age.train_at_level = getTrainingAge(this.fit20.durationTable,
        //       this.fit20.qsTable,
        //       this.fit20.weightedTable,
        //       this.fit20.trainingAgeTable[this.selectedMember.gender],
        //       [...last3ValidSessions, this.newSession],
        //       this.fit20.QSType,
        //       this.fit20.studioMachines,
        //       this.fit20.minAgeExercise);
        //     this.trainingAge = this.newSession.training_age.train_at_level;
        //   }
        //   console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>> Traing Age <<<<<<<<<<<<<<<<<<<<<<<<<<<");
        //   console.log(this.newSession.training_age.train_at_level);
        //   let firstSessionsPerMonth = this.getFirstSessionPerMonth(this.sessions.slice(0, 12));
        //   console.log({ firstSessionsPerMonthLength: firstSessionsPerMonth.length });
        //   console.log(firstSessionsPerMonth);

        //   //// make sure the difference is not more than (min difference)
        //   if (firstSessionsPerMonth.length > 0) {
        //     let lastValidTrainingAge = firstSessionsPerMonth.slice().reverse().find(
        //       session => session.training_age.train_at_level && session.training_age.train_at_level > 15
        //     );

        //     if (lastValidTrainingAge) {
        //       let difference = this.newSession.training_age.train_at_level - lastValidTrainingAge.training_age.train_at_level;
        //       console.log({ difference });
        //       if (Math.abs(difference) > this.fit20.maxIncrease) {
        //         console.log("make sure the difference is not more than (min difference)");
        //         this.newSession.training_age.train_at_level =
        //           Math.round(lastValidTrainingAge.training_age.train_at_level + Math.sign(difference) * this.fit20.maxIncrease);
        //         this.trainingAge = Math.round(this.newSession.training_age.train_at_level);
        //         console.log({ trainingAgeAfterCorrection: this.newSession.training_age.train_at_level })
        //       }
        //       if (Math.abs(difference) > this.fit20.maxDecrease) {
        //         console.log("make sure the difference is not more than (min difference)");
        //         this.newSession.training_age.train_at_level =
        //           Math.round(lastValidTrainingAge.training_age.train_at_level + Math.sign(difference) * this.fit20.maxDecrease);
        //         this.trainingAge = Math.round(this.newSession.training_age.train_at_level);
        //         console.log({ trainingAgeAfterCorrection: this.newSession.training_age.train_at_level })
        //       }
        //     }
        //   }

        // }
        try {
          await fetch(`${this.fit20.hostProtocol}${oldMachineInStudio.ipAddress}:${this.fit20.MSA_port}/exercise/stop`, {
            method: 'POST',
            body: JSON.stringify({
              total: QS.average,
              range: QS.range,
              rhythm: QS.rhythm,
              tempo: QS.tempo,
              best_score: bestScore, // allTimeBest - correntBest - tempo - rhythm - range - ""
              motivational_msg: this.msg,
              overall_QS: this.lastExercise && this.newSession.training_age.overall_qs && this.newSession.training_age.overall_qs.qs_average ? this.newSession.training_age.overall_qs.qs_average : 0,
              lang: this.fit20.user.language,
              training_age: null,//this.lastExercise && this.newSession.training_age.train_at_level ? Math.round(this.newSession.training_age.train_at_level) : null,
              training_age_text: '',//this.$t('training-age-msg', this.getCorrectLang())
            }),
          });
        } catch (err) {
          console.log({ err });
          this.fit20.errors.push("Error in stopExersice in Session.vue " + formattedDateTime());
          this.fit20.errors.push(JSON.stringify({
            message: err.message,
            stack: err.stack,
            name: err.name,
          }) + " " + formattedDateTime());
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: 'Network error!' });
        }
      }
      /////////////// TO DO >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
      if (this.counter < 30) {
        this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('invalid-exercise') });
        await this.closeWebSocket(oldMachineInStudio);
      }
      // console.log(this.newSession);
      // console.log(this.selectedMember);
      // console.log(this.newSession);
      // let tempSessions = localStorage.getItem(this.fit20.studio); // should be an array 
      // if (tempSessions && tempSessions.length > 0) {
      //   let targetedSession = tempSessions.find(session => session.member == this.newSession.member);
      //   if (targetedSession) {
      //     targetedSession = this.newSession;
      //     localStorage.setItem(this.fit20.studio, tempSessions);
      //   } else {
      //     // push the new session
      //     tempSessions.push(this.newSession);
      //     localStorage.setItem(this.fit20.studio, tempSessions);
      //   }
      // } else {
      //   // push the new session
      //   tempSessions.push(this.newSession);
      //   localStorage.setItem(this.fit20.studio, tempSessions);
      // }


      let tempSessions = JSON.parse(localStorage.getItem(this.fit20.studio.id)) || [];

      let targetedIndex = tempSessions.findIndex(
        session => session.member == this.newSession.member
      );

      if (targetedIndex !== -1) {
        // update existing session
        tempSessions[targetedIndex] = this.newSession;
      } else {
        // add new session
        if (this.newSession.id != 'new_session') {
          this.newSession.member = this.selectedMember.id;
        }
        tempSessions.push(this.newSession);
      }

      localStorage.setItem(
        this.fit20.studio.id,
        JSON.stringify(tempSessions)
      );
      // console.log(JSON.parse(localStorage.getItem(this.fit20.studio.id)));
    },
    unselectExercise: async function (disconnect) {
      this.fit20.errors.push("start unselectExercise for " + this.selectedMember.displayFirstName + " " + formattedDateTime());
      try {


        this.personalBest = {
          allWeights: '',
          thisWeight: '',
          last5Session: ''
        }
        this.QS = false;
        this.trainingAge = '';
        this.showStationary = false;
        let oldMachineInStudio = false;

        if (this.selectedMachine.id) {
          let selectedMachine = JSON.parse(JSON.stringify(this.selectedMachine.id));

          oldMachineInStudio = this.fit20.studio.machines.find(machine => machine.id == selectedMachine || selectedMachine == '1001' && machine.id == this.fit20.newLegPress);
        }
        if (disconnect) {
          this.fit20.errors.push("before closeWebSocket " + this.selectedMember.displayFirstName + " " + formattedDateTime());
          this.fit20.errors.push("before closeWebSocket oldMachineInStudio: " + oldMachineInStudio + " " + formattedDateTime());
          await this.closeWebSocket(oldMachineInStudio);
          this.fit20.errors.push("After closeWebSocket " + this.selectedMember.displayFirstName + " " + formattedDateTime());

          console.log('after closeWebSocket');
        }
        this.fit20.errors.push("selectedMachine.id " + this.selectedMachine.id + " " + formattedDateTime());
        if (this.selectedMachine.id) {
          this.fit20.errors.push("Start unselect exe css " + this.selectedMember.displayFirstName + " " + formattedDateTime());
          $('.machine-' + this.selectedMachine.id + ':not(.selected-machine-finish)').removeClass('unselected');
          $('.machine-' + this.selectedMachine.id + '-' + this.selectedMember.id).removeClass('selected-machine');
          $('.machine-' + this.selectedMachine.id + '-' + this.selectedMember.id).addClass('selected-machine-finish');
        }
        // TO DO
        // should set the brightness to low level >>>>>>>>>>>>>>>>>
        this.exerciseStopped = false;
        this.isExerciseSelected = false;
        this.sensorData = [];
        this.fit20.exercisesControl['tab' + (this.tabNum + 2)].shift();
      } catch (err) {
        this.fit20.errors.push("Error in unselectExercise for " + this.selectedMember.displayFirstName + " " + formattedDateTime());
        this.fit20.errors.push(JSON.stringify({
          message: err.message,
          stack: err.stack,
          name: err.name,
        }) + " " + formattedDateTime());
      }
    },
    showStartBtn: function (open, start, editTime) {
      if (open) {
        this.showStartBtnPopup = true;
      } else {
        this.showStartBtnPopup = false;
        if (start) {
          this.fit20.tabs['tab' + (this.tabNum + 2)]['action'] = 'exercise started' + new Date();
          if (this.closeWebSocketTimeout) {
            clearTimeout(this.closeWebSocketTimeout);
            this.closeWebSocketTimeout = false;
          }
        }
        if (editTime) {
          this.editTimePopup = true;
        }
      }

    },
    startCounter: function () {
      const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
      this.counter = -3 + elapsed;
      if (this.counter < 0) {
        this.showCountDown = true;
        this.countDown = this.countDown - 1;
      } else if (this.counter == 0) {
        this.countDown = 'Go'
      }
      if (this.counter > 0) {
        if (this.showCountDown) {
          this.showCountDown = false;
        }
        if (!this.exerciseStarted) {
          this.exerciseStarted = true;
          this.repCount = 1;
          this.secondCount = 1;
        }
        this.selectedExercise.duration = JSON.parse(JSON.stringify(this.counter));
      }
    },
    startStationaryCounter: function () {
      if (this.stationaryCounter != 0) {
        this.stationaryCounter = this.stationaryCounter - 1;
      }

      if (this.stationaryCounter == 0) {
        clearInterval(this.stationaryInterval);
        this.stationaryInterval = "";
      }
    },
    setExerciseWeight: function (machineId) {
      let foundExercises = [];
      if (this.displayedSessions.length < 1) {
        return this.selectedMachine.defaultWeight;
      } else {
        this.displayedSessions.forEach(session => {
          let foundExercise = session.exercises.find(exercise => exercise.machineId == machineId);
          if (foundExercise && foundExercise.weight && foundExercise.weight > 0) {
            foundExercises.push(foundExercise);
          }
        })
        if (foundExercises.length > 0) {
          return foundExercises[0].weight || this.selectedMachine.defaultWeight;
        } else {
          return this.selectedMachine.defaultWeight;
        }
      }
    },
    changeExerciseWeight: function (machineId, value) {
      if (machineId) {
        this.selectedExercise.weight = Number(value);
      } else {
        this.isWeightDropdownOpen = !this.isWeightDropdownOpen;
        if (this.isWeightDropdownOpen) {
          this.$nextTick(() => {
            const selectedWeightElement = document.getElementById('selected_weight' + this.member.id);
            if (selectedWeightElement) {
              selectedWeightElement.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          });
        }
      }

    },
    hasPartners: function (member) {
      if (member) {
        let currentStudio = member.studios.find(studio => studio.id == this.fit20.studio.id);
        if (currentStudio && currentStudio.partners && currentStudio.partners.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    editSession: function (session, num) {
      let isContinue = false;
      if (num) {
        session.number = num;
        isContinue = true;
      }
      if (!num) {
        if (!session.id) {
          session.id = 'new_session';
        }
        isContinue = true;
      }
      // console.log(num);
      if (isContinue) {
        this.newSession = JSON.parse(JSON.stringify(session));
        this.$nextTick(() => {
          let height = (this.fit20.studio.machines.length + 1) * 42;
          const elements = document.getElementsByClassName('new-session');
          for (var i = 0; i < elements.length; i++) {
            elements[i].style.setProperty('--before-height', height + 'px');
          }
        });
        this.fit20.tabs['tab' + (this.tabNum + 2)]['active'] = true;
        // this.fit20.tabs['tab' + (this.tabNum + 2)]['action'] = "";
        if (this.fit20.errors.length > 2) {
          this.fit20.errors = [this.fit20.errors[0], this.fit20.errors[1]];
        }

      }

    },
    capitalizeFirstLetter(string) {
      if (string) {
        return string[0].toUpperCase() + string.slice(1);
      } else {
        return '';
      }
    },
    togglePopup: async function (open, machineSetting) {
      if (machineSetting) {
        this.showEditMachineSetting = !this.showEditMachineSetting;
        this.selectedMachine = machineSetting;
        if (!open) {
          this.setMachineSetting(this.selectedMember.machinesSettings);
          this.isDropdownOpenIndex = -1;
          this.selectedMachine = false;
        }
      }
    },
    unselectMachine: async function () {
      await this.unselectExercise(true);
      this.selectedMachine = false;

    },
    selectMachine: async function (machine, e) {
      if (this.closeWebSocketTimeout) {
        clearTimeout(this.closeWebSocketTimeout);
        this.closeWebSocketTimeout = false;
      }
      this.QS = false;
      let oldMachineInStudio = false;
      if (this.selectedMachine.id) {
        oldMachineInStudio = this.fit20.studio.machines.find(machine => machine.id == this.selectedMachine.id || this.selectedMachine.id == '1001' && machine.id == this.fit20.newLegPress);
      }

      if (this.exerciseStarted) {
        await this.closeWebSocket(oldMachineInStudio);
        this.stopExercise(oldMachineInStudio);
      }

      if (oldMachineInStudio) {
        await this.unselectExercise(true);
      }
      this.counter = -4;
      this.countDown = 4;
      this.stationaryInterval = "";
      this.isWeightDropdownOpen = false;

      if (this.selectedMachine.id) {
        $('.machine-' + this.selectedMachine.id + `:not(.machine-${this.selectedMachine.id}-${this.selectedMember.id})`).removeClass('unselected');
        $('.machine-' + this.selectedMachine.id + '-' + this.selectedMember.id).removeClass('selected-machine-finish');
        let oldMachineUnselected = $(`.machine-${this.selectedMachine.id}-${this.selectedMember.id}.unselected`);

        if (oldMachineUnselected && oldMachineUnselected.length == 1) {
          this.oldMachineUnselected = JSON.parse(JSON.stringify(this.selectedMachine.id + '-' + this.selectedMember.id));
        } else if (this.oldMachineUnselected.length > 5) {
          let oldMachineUnselected2 = $(`.machine-${this.oldMachineUnselected}.unselected`);
          if (oldMachineUnselected2 && oldMachineUnselected2.length == 1) {
            // do nothing
          } else {
            this.oldMachineUnselected = '';
          }
        } else {
          this.oldMachineUnselected = '';

        }

      }
      this.selectedMachine = JSON.parse(JSON.stringify(machine));

      if (this.activeSession) {
        const ele = document.getElementById('machine_remark' + this.member.id);
        if (ele) {
          ele.innerText = this.machinesRemarks[this.selectedMachine.id];



        }
        if (this.selectedExercise.machineId) {
          if (!this.selectedExercise.duration || this.selectedExercise.duration < 15) {
            const indexToRemove = this.newSession.exercises.findIndex(exe => exe.machineId == this.selectedExercise.machineId);
            if (indexToRemove != -1) {
              this.newSession.exercises.splice(indexToRemove, 1);
            }
          } else {
            // here there is duration we should give an order !!!!!!!!!!!!!!
            if (this.selectedExercise.order == '-') {
              this.selectedExercise.order = this.newSession && this.newSession.exercises && this.newSession.exercises.length ? this.newSession.exercises.length : "?";
            }
            // we should handle this or last selected exercise on save session
            if (this.newExerciseRemark && this.newExerciseRemark != this.selectedExercise.remark) {
              const exerciseToUpdate = this.newSession.exercises.find(exe => exe.machineId == this.selectedExercise.machineId);
              exerciseToUpdate.remark = JSON.parse(JSON.stringify(this.newExerciseRemark));
            }
          }
        }
        let findExercise = this.newSession.exercises.find(exe => exe.machineId == machine.id);
        if (findExercise) {
          this.selectedExercise = findExercise;
        } else {
          this.selectedExercise = {
            machineId: machine.id,
            order: "-",
            weight: this.setExerciseWeight(machine.id),
            duration: "",
            weightChange: '',
            qs_average: 0,
            qs_range: 0,
            qs_rhythm: 0,
            qs_tempo: 0,
            remark: '',
            sensor_position: '',
          }
          this.newSession.exercises.push(this.selectedExercise);
        }
        const machineRemark = document.getElementById('exercise_remark' + this.member.id);
        if (machineRemark) {
          machineRemark.innerText = this.selectedExercise.remark;
        }

      }

      this.isExerciseSelected = true;
      $('.machine-' + machine.id + ':not(.selected-machine)').addClass('unselected');
      if (this.oldMachineUnselected.length < 1) {
        $('.machine-' + machine.id + '-' + this.selectedMember.id + ':not(.selected-machine)').removeClass('unselected');
        $('.machine-' + machine.id + '-' + this.selectedMember.id).addClass('selected-machine');
      }

      this.newExerciseRemark = "";

      // the condition should adjust after rebuild the studios
      if ((this.fit20.studio.sensor) && this.machineSetting[this.selectedMachine.id][5]['image'] == 'sensor-green') {

        // second condition is to handel the new leg press
        let machineInStudio = this.fit20.studio.machines.find(machine => machine.id == this.selectedMachine.id || this.selectedMachine.id == '1001' && machine.id == this.fit20.newLegPress);
        // 1001


        if (machineInStudio && machineInStudio.ipAddress) {
          this.fit20.isLoaded = false;
          let startCalibration = 0;
          let endCalibration = 200;
          let machineSetting = this.selectedMember.machinesSettings.find(machine => machine.machineId == this.selectedMachine.id && machine.studioId == this.fit20.studio.id);
          if (machineSetting) {
            startCalibration = machineSetting.startCalibration ? machineSetting.startCalibration : 0;
            endCalibration = machineSetting.endCalibration ? machineSetting.endCalibration : 200;
          }
          this.fit20.errors.push("startCalibration : " + this.selectedMachine.name + " of " + this.selectedMember.firstName + " " + startCalibration + " " + formattedDateTime());
          this.fit20.errors.push("endCalibration : " + this.selectedMachine.name + " of " + this.selectedMember.firstName + " " + endCalibration + " " + formattedDateTime());
          const data = {
            "machine": {
              "id": this.selectedMachine.id,
              "name": this.selectedMachine.name
            },
            "colorScheme": [
              { "tracking": 0.05, "color": "#92D400" },
              { "tracking": 0.07, "color": "#DDDD00" },
              { "tracking": 0.1, "color": "#EECC00" },
              { "tracking": 0.13, "color": "#FF9900" },
              { "tracking": 0.2, "color": "#EE5500" }
            ],
            "member": {
              "id": this.member.id,
              "name": this.member.displayFirstName + " " + this.member.displayLastName
            },
            "trackingFactor": 1,
            "easingFactor": 1.5,
            "calibration": {
              "inStudioId": this.fit20.studio.id,
              "start": startCalibration,
              "end": endCalibration
            }
          };
          try {
            // get sensor position :
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 7000);
            let getPosition = await fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/position`, { method: 'GET', signal: controller.signal, });
            let position;

            if (getPosition.status != 500) {
              position = await getPosition.json();
              if (position) {
                this.selectedExercise.sensor_position = position.sensor_reading;
                this.fit20.errors.push("MSA v : " + this.selectedMachine.name + " : " + position.appVersion + " " + formattedDateTime());
                this.fit20.errors.push("Sensor Connection State: " + this.selectedMachine.name + " : " + position.sensorConnectionState + " " + formattedDateTime());
              }
              clearTimeout(timeoutId);

              const controller2 = new AbortController();
              const timeoutId2 = setTimeout(() => controller2.abort(), 7000);
              let setConfigure = await fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/configure?reset`, {
                signal: controller2.signal,
                method: 'POST',
                body: JSON.stringify(data), // Convert data to JSON string
              });
              // let configure = await setConfigure.json();
              if (!setConfigure.ok) {
                this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: 'Network error' });
                this.socket = false;
              } else {

                await fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/brightness`, {
                  method: 'POST',
                  body: JSON.stringify({ "level": 178 }),
                });
                this.openWebSocket(`ws://${machineInStudio.ipAddress}:${this.fit20.MSA_port}/exercise/data`);
                this.closeWebSocketTimeout = setTimeout(async () => {
                  await this.closeWebSocket(machineInStudio);
                  this.fit20.errors.push("websocket closed because it was open for longer than 5 min " + formattedDateTime());
                  //this.fit20.errMsgs.push({ id: Date.now(), type: 'warn', msg: this.$t('sensor-connected-to-long') })
                }, 7 * 60 * 1000); // 5 minutes in milliseconds

              }

              clearTimeout(timeoutId2);
              this.fit20.isLoaded = true;
            } else {
              let err = await getPosition.text();
              this.fit20.errors.push("Error in selectMachine in Session.vue " + err + formattedDateTime());
              const firstLine = err.split('\n')[0];
              this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: firstLine ? firstLine : 'General Network error!' });
              this.fit20.isLoaded = true;
            }

            //console.log(position);
            //console.log(position.sensor_reading);

          } catch (err) {
            console.log({ err });
            this.fit20.errors.push("Error in selectMachine in Session.vue " + formattedDateTime());
            this.fit20.errors.push(JSON.stringify({
              message: err.message,
              stack: err.stack,
              name: err.name,
            }) + " " + formattedDateTime());
            this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: err.message ? err.message : 'General Network error!' });
            this.socket = false;
            this.fit20.isLoaded = true;
          }
        } else {
          // alert that there is no ipAddress has been found
          this.socket = false;

          this.fit20.errors.push("Error in selectMachine No IP address in Session.vue " + formattedDateTime());
          // this.fit20.errors.push(JSON.stringify({
          //   message: err.message,
          //   stack: err.stack,
          //   name: err.name,
          // }) + " " + formattedDateTime());
          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('no-ip-address') });
        }
      }
    },
    getOscillatingValue: function (ms) {
      const cycleLength = 20; // 1→10 then 10→1 = 20 steps
      const step = (Math.floor(ms / 1000) % cycleLength) + 1; // 1 step per second

      return step <= 10 ? step : 20 - step + 1;
    },
    openWebSocket: function (url) {
      const vm = this;
      this.socket = new WebSocket(url, 'websocket');
      // let youBar = document.getElementById('you_bar' + this.selectedMember.id);
      // let followMeBar = document.getElementById('follow_me_bar' + this.selectedMember.id);
      // Event listener for when the connection is established
      this.socket.onopen = function (event) {
        console.log('WebSocket connected!');
      };

      let lastUpdateTime = 0;
      const updateInterval = 33;
      //1000 / 45; // ~45ms for 30 FPS

      this.socket.onmessage = function (event) {
        const now = Date.now();
        const data = JSON.parse(event.data);

        if (now - lastUpdateTime >= updateInterval) {
          lastUpdateTime = now;

          let dataValue = data.actualPosition;
          let difference = data.tracking;

          if (this.exerciseStarted && !this.showStationary) {
            this.sensorData.push(data);
          }

          let percentageValue = this.mapValueToPercentage(dataValue, 0, 1, 10, 90);
          let followMeValue = this.mapValueToPercentage(data.referencePosition, 0, 1, 10, 90);

          if (dataValue < 0) {
            percentageValue = this.mapValueToPercentage(dataValue, -0.10, 0, 0, 10);
          } else if (dataValue > 1) {
            percentageValue = this.mapValueToPercentage(dataValue, 1, 1.10, 90, 100);
          }

          // youBar.style.width = percentageValue + '%';
          // followMeBar.style.width = followMeValue + '%';

          this.youBarWidth = percentageValue + '%';
          this.followMeBarWidth = followMeValue + '%';

          if (difference >= 0 && difference <= 0.07) {
            if (this.youBarBgColor !== '#92D400') {
              this.youBarBgColor = '#92D400';
            }
          } else if (difference > 0.07 && difference <= 0.1) {
            if (this.youBarBgColor !== '#DDDD00') {
              this.youBarBgColor = '#DDDD00';
            }
          } else if (difference > 0.1 && difference <= 0.13) {
            if (this.youBarBgColor !== '#EECC00') {
              this.youBarBgColor = '#EECC00';
            }
          } else if (difference > 0.13 && difference <= 0.2) {
            if (this.youBarBgColor !== '#FF9900') {
              this.youBarBgColor = '#FF9900';
            }
          } else {
            if (this.youBarBgColor !== '#EE5500') {
              this.youBarBgColor = '#EE5500';
            }
          }

          // if (difference >= 0 && difference <= 0.07) {
          //   youBar.style.backgroundColor = '#92D400';
          // } else if (difference > 0.07 && difference <= 0.1) {
          //   youBar.style.backgroundColor = '#DDDD00';
          // } else if (difference > 0.1 && difference <= 0.13) {
          //   youBar.style.backgroundColor = '#EECC00';
          // } else if (difference > 0.13 && difference <= 0.2) {
          //   youBar.style.backgroundColor = '#FF9900';
          // } else {
          //   youBar.style.backgroundColor = '#EE5500';
          // }

          if (this.repCount > 0 && data.halfRepetition % 2 == 1 && data.halfRepetition / 2 > this.repCount) {
            this.repCount = this.repCount + 1;


            // if we activate the reconnecting we should also do the following :
            // this.repCount = data.halfRepetition / 2;
          }
          if (this.secondCount > 0 && data.count > 0) {
            this.secondCount = data.count;
          }
        }
      }.bind(this);

      // Event listener for incoming messages
      // this.socket.onmessage = function (event) {
      //   let data = JSON.parse(event.data);
      //   let dataValue = data.actualPosition;
      //   let difference = data.tracking;
      //   // console.log(data);
      //   if (vm.exerciseStarted && !vm.showStationary) {
      //     vm.sensorData.push(data);
      //     // console.log('pushing');
      //   }
      //   // Map the data value to a percentage between 0% and 100%
      //   let percentageValue = vm.mapValueToPercentage(dataValue, 0, 1, 10, 90);
      //   let followMeValue = vm.mapValueToPercentage(data.referencePosition, 0, 1, 10, 90);

      //   // Adjust the percentage value if it goes beyond 10% or 90%
      //   if (dataValue < 0) {
      //     percentageValue = vm.mapValueToPercentage(dataValue, -0.10, 0, 0, 10);
      //   } else if (dataValue > 1) {
      //     percentageValue = vm.mapValueToPercentage(dataValue, 1, 1.10, 90, 100);
      //   }

      //   youBar.style.width = percentageValue + '%'
      //   followMeBar.style.width = followMeValue + '%'
      //   if (difference >= 0 && difference <= 0.07) {
      //     youBar.style.backgroundColor = '#92D400';
      //   } else if (difference > 0.07 && difference <= 0.1) {
      //     youBar.style.backgroundColor = '#DDDD00';
      //   } else if (difference > 0.1 && difference <= 0.13) {
      //     youBar.style.backgroundColor = '#EECC00';
      //   } else if (difference > 0.13 && difference <= 0.2) {
      //     youBar.style.backgroundColor = '#FF9900';
      //   } else {
      //     youBar.style.backgroundColor = '#EE5500';
      //   }

      //   if (vm.repCount > 0 && data.halfRepetition % 2 == 1 && data.halfRepetition / 2 > vm.repCount) {
      //     vm.repCount = vm.repCount + 1;
      //   }
      //   if (vm.secondCount > 0 && data.count > 0) {
      //     vm.secondCount = data.count;
      //   }
      // };

      // Event listener for errors
      this.socket.onerror = function (error) {
        vm.socket = false;
        // can we find a way to reconnect at least one time ?????????????????
        // maybe something like new api just for open the web sucket but that will miss the counting




        // if there is a qs send all necessary req
        //console.error('WebSocket error:', error);
      };

      // Event listener for when the connection is closed
      this.socket.onclose = function (event) {
        //console.log('WebSocket closed:', event.code, event.reason);
        vm.$root.$emit('close-cali-popup' + vm.selectedMember.id);
        vm.socket = false;
      };

    },
    closeWebSocket: async function (machine, stop) {
      try {
        console.log('start closing the ws');
        if (this.socket) {
          console.log('there is ws');
          if (this.socket.readyState === WebSocket.OPEN) {
            console.log('it is open');
            try {
              this.socket.close();
              console.log('closed');
            } catch (error) {
              console.warn('Ignoring WebSocket error on close:', error);
            }
          }
          this.socket = false;
        }
        let machineInStudio;
        if (machine && machine.id) {
          machineInStudio = this.fit20.studio.machines.find(machine2 => machine2.id == machine.id || machine.id == '1001' && machine2.id == this.fit20.newLegPress);
        }

        if (machineInStudio && machineInStudio.id == this.fit20.newLegPress) {
          if (machine) {
            machine.id = '1001'
          }
        }

        if (machine && machineInStudio && machineInStudio.ipAddress && !stop && this.isExerciseSelected && this.machineSetting[machine.id] && this.machineSetting[machine.id][5] && this.machineSetting[machine.id][5].image == "sensor-green") {

          const controller = new AbortController();
          this.fit20.isLoaded = false;
          const timeoutId = setTimeout(() => controller.abort(), 2000);
          try {
            await fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/exercise/finish`, { method: 'GET', signal: controller.signal, });
          } catch (err) {
            console.log(err);
            this.fit20.errors.push("(error in finish exe req " + this.selectedMember.displayFirstName + '  ' + formattedDateTime());
            clearTimeout(timeoutId);
          }
          clearTimeout(timeoutId);
          this.fit20.isLoaded = true;
          fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/brightness`, {
            method: 'POST',
            body: JSON.stringify({ "level": 12 }),
          });
        }
      } catch (err) {
        this.fit20.errors.push("(error in closeWebSocket " + this.selectedMember.displayFirstName + '  ' + formattedDateTime());
        this.fit20.errors.push(JSON.stringify({
          message: err.message,
          stack: err.stack,
          name: err.name,
        }) + " " + formattedDateTime());
      }
    },
    setMachineExecute: async function (machineId, directSave) {
      if (this.executeMachine[machineId] == 2) {
        this.executeMachine[machineId] = 0;
      } else {
        this.executeMachine[machineId] += 1;
      }
      this.executeMachine = JSON.parse(JSON.stringify(this.executeMachine));
      if (directSave) {
        await this.saveMemberMachineSetting(machineId, directSave);
      }
    },
    editMachineSetting: async function (machineId, index, value, event, directSave) {
      if (!directSave) { this.fit20.isLoaded = false; }

      if (event) {
        event.stopPropagation();
      }
      if ([3, 4, 5].includes(index) || (machineId == '3001' && index == 0)) {
        if (this.machineSetting[machineId][index].image) {
          if (this.machineSetting[machineId][index].image.length == 4) {
            this.machineSetting[machineId][index].image = '^' + this.machineSetting[machineId][index].image;
          } else if (this.machineSetting[machineId][index].image.length > 5) {
            if (this.machineSetting[machineId][index].image == 'sensor-green') {
              this.machineSetting[machineId][index].image = 'sensor-red';
            } else {
              this.machineSetting[machineId][index].image = 'sensor-green';
            }
          } else {
            this.machineSetting[machineId][index].image = this.machineSetting[machineId][index].image.slice(1);
          }
          this.machineSetting = JSON.parse(JSON.stringify(this.machineSetting));
        }
        // if (directSave) {
        //   await this.saveMemberMachineSetting(machineId, directSave);
        // }

        if (!directSave) { this.fit20.isLoaded = true; }
      } else {
        if (this.machineSetting[machineId][index].image) {

          if (!value) {
            this.isDropdownOpenIndex = index;
          } else {
            this.machineSetting[machineId][index].value = value;
            this.isDropdownOpenIndex = -1;
            this.machineSetting = JSON.parse(JSON.stringify(this.machineSetting));
            // if (directSave) {
            //   await this.saveMemberMachineSetting(machineId, directSave);
            // }
          }
          if (!directSave) { this.fit20.isLoaded = true; }
        }
      }
    },
    setMachineSetting: function (memberMachineSetting) {
      this.fit20.studioMachines.forEach(machine => {
        this.machineSetting[String(machine.id)] = this.setMachineSettingImage(memberMachineSetting, machine.id);
        let setting = memberMachineSetting.find(machines => machines.machineId == machine.id && machines.studioId == this.fit20.studio.id);
        if (setting) {
          this.executeMachine[String(machine.id)] = setting.execute;
          this.machinesRemarks[String(machine.id)] = setting.remark ? setting.remark : '';
        } else {
          this.executeMachine[String(machine.id)] = 0;
          this.machinesRemarks[String(machine.id)] = '';
        }
      })
    },

    setMachineSettingImage: function (memberMachineSetting, machineId) {

      let settings = [{}, {}, {}, {}, {}, {}];
      let machine = memberMachineSetting.find(machine => machine.machineId == machineId && machine.studioId == this.fit20.studio.id);
      if (machineId == '3001') { // chest press
        settings[0].image = machine && machine.values[2] == 1 ? '0020' : "^0020";
        settings[1].image = '^0002';
        settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
        settings[1].values = this.fit20.studioMachines.find(machine => machine.id == '3001').adjustable[1].values.split(' ');
        settings[2].image = "^0006";
        settings[2].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[2].values = this.fit20.studioMachines.find(machine => machine.id == '3001').adjustable[0].values.split(' ');
        settings[3].image = machine && machine.values[3] == 1 ? '0012' : "^0012";
        settings[4].image = machine && machine.values[4] == 1 ? '0028' : "^0028";
        settings[5].image = this.fit20.studio.sensor && machine && machine.sensor ? 'sensor-green' : this.fit20.studio.sensor ? "sensor-red" : '';
      }
      if (machineId == '5001') { // latpull
        settings[0].image = '^0008';
        settings[0].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
        // console.log(machine.values[1]);
        settings[0].values = this.fit20.studioMachines.find(machine => machine.id == '5001').adjustable[1].values.split(' ');
        settings[1].image = '^0002';
        settings[1].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[1].values = this.fit20.studioMachines.find(machine => machine.id == '5001').adjustable[0].values.split(' ');
        settings[5].image = this.fit20.studio.sensor && machine && machine.sensor ? 'sensor-green' : this.fit20.studio.sensor ? "sensor-red" : '';
      }
      if (machineId == '1001') { // leg press
        settings[1].image = '^0002';
        settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
        settings[1].values = this.fit20.studioMachines.find(machine => machine.id == '1001').adjustable[1].values.split(' ');
        settings[2].image = "^0006";
        settings[2].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[2].values = this.fit20.studioMachines.find(machine => machine.id == '1001').adjustable[0].values.split(' ');
        settings[5].image = this.fit20.studio.sensor && machine && machine.sensor ? 'sensor-green' : this.fit20.studio.sensor ? "sensor-red" : '';
      }
      if (machineId == '4001') { //abdominal
        settings[1].image = '^0002';
        settings[1].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[1].values = this.fit20.studioMachines.find(machine => machine.id == '4001').adjustable[0].values.split(' ');
        settings[4].image = machine && machine.values[1] == 1 ? '0028' : "^0028";
        settings[5].image = this.fit20.studio.sensor && machine && machine.sensor ? 'sensor-green' : this.fit20.studio.sensor ? "sensor-red" : '';
      }
      if (machineId == '1002') { // back extinction
        settings[0].image = '^0004';
        settings[0].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
        settings[0].values = this.fit20.studioMachines.find(machine => machine.id == '1002').adjustable[1].values.split(' ');
        settings[1].image = '^0002';
        settings[1].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[1].values = this.fit20.studioMachines.find(machine => machine.id == '1002').adjustable[0].values.split(' ');
        settings[3].image = machine && machine.values[3] == 1 ? '0044' : "^0044";
        settings[4].image = machine && machine.values[2] == 1 ? '0028' : "^0028";
        settings[5].image = this.fit20.studio.sensor && machine && machine.sensor ? 'sensor-green' : this.fit20.studio.sensor ? "sensor-red" : '';
      }
      if (machineId == '4002') { // adduction
        settings[0].image = '^0026';
        settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[0].values = this.fit20.studioMachines.find(machine => machine.id == '4002').adjustable[0].values.split(' ');
        settings[3].image = machine && machine.values[1] == 1 ? '0032' : "^0032";
        settings[4].image = machine && machine.values[2] == 1 ? '0036' : "^0036";
        settings[5].image = this.fit20.studio.sensor && machine && machine.sensor ? 'sensor-green' : this.fit20.studio.sensor ? "sensor-red" : '';
      }
      if (machineId == '2002') { // abduction
        settings[3].image = machine && machine.values[1] == 1 ? '0032' : "^0032";
        settings[4].image = machine && machine.values[0] == 1 ? '0036' : "^0036";
        settings[5].image = this.fit20.studio.sensor && machine && machine.sensor ? 'sensor-green' : this.fit20.studio.sensor ? "sensor-red" : '';
      }
      if (machineId == '5872645769789440') { // mid row
        settings[0].image = '^0042';
        settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[0].values = this.fit20.studioMachines.find(machine => machine.id == '5872645769789440').adjustable[0].values.split(' ');
        settings[1].image = '^0002';
        settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
        settings[1].values = this.fit20.studioMachines.find(machine => machine.id == '5872645769789440').adjustable[1].values.split(' ');
      }
      if (machineId == '5002') { // RC
        settings[0].image = '^0022';
        settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[0].values = this.fit20.studioMachines.find(machine => machine.id == '5002').adjustable[0].values.split(' ');
        settings[1].image = '^0024';
        settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
        settings[1].values = this.fit20.studioMachines.find(machine => machine.id == '5002').adjustable[1].values.split(' ');
      }
      if (machineId == '707003' || machineId == '712001' || machineId == '725087' || machineId == '5218291781992448' || machineId == "5251620728209408") { // TL,TR, TS
        settings[0].image = '^0026';
        settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[0].values = this.fit20.studioMachines.find(machine => machine.id == machineId).adjustable[0].values.split(' ');
        settings[3].image = machine && machine.values[1] == 1 ? '0012' : "^0012";
      }
      if (machineId == "166046" || machineId == "73017") { // TL,TR, rechts links
        settings[0].image = '^0026';
        settings[0].value = machine && machine.values && machine.values[0] ? machine.values[0] : 0;
        settings[0].values = this.fit20.studioMachines.find(machine => machine.id == machineId).adjustable[0].values.split(' ');
        settings[1].image = '^0002';
        settings[1].value = machine && machine.values && machine.values[1] ? machine.values[1] : 0;
        settings[1].values = this.fit20.studioMachines.find(machine => machine.id == machineId).adjustable[0].values.split(' ');
        settings[3].image = machine && machine.values[2] == 1 ? '0012' : "^0012";
      }
      return settings;
    },
    updateMemberMachineSetting: function (machineId) {

      let machineToUpdate = this.selectedMember.machinesSettings.find(machine => machine.machineId == machineId && this.fit20.studio.id == machine.studioId);
      let newSetting = {};
      newSetting.values = ['', '', '', '', ''];
      newSetting.execute = this.executeMachine[machineId];
      newSetting.sensor = this.machineSetting && this.machineSetting[String(machineId)] && this.machineSetting[String(machineId)].length >= 5 && this.machineSetting[String(machineId)][5].image == 'sensor-green' ? true : false;
      newSetting.startCalibration = machineToUpdate && machineToUpdate.startCalibration ? machineToUpdate.startCalibration : '';
      newSetting.endCalibration = machineToUpdate && machineToUpdate.endCalibration ? machineToUpdate.endCalibration : '';
      if (machineId == '3001') { // chest press
        newSetting.values[0] = this.machineSetting[String(machineId)][2].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
        newSetting.values[2] = this.machineSetting[String(machineId)][0].image.includes('^') ? 0 : 1;
        newSetting.values[3] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
        newSetting.values[4] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
      }
      if (machineId == '5001') { // latpull
        newSetting.values[0] = this.machineSetting[String(machineId)][1].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][0].value;
      }
      if (machineId == '1001') { // leg press
        newSetting.values[0] = this.machineSetting[String(machineId)][2].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
      }
      if (machineId == '4001') { //abdominal
        newSetting.values[0] = this.machineSetting[String(machineId)][1].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
      }
      if (machineId == '1002') { // back extinction
        newSetting.values[0] = this.machineSetting[String(machineId)][1].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][0].value;
        newSetting.values[2] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
        newSetting.values[3] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
      }
      if (machineId == '4002') { // adduction
        newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
        newSetting.values[2] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
      }
      if (machineId == '2002') { // abduction
        newSetting.values[0] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
        newSetting.values[1] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
      }
      if (machineId == '5872645769789440') { // mid row
        newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
      }
      if (machineId == '5002') { // RC
        newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
      }
      if (machineId == '707003' || machineId == '712001' || machineId == '725087' || machineId == '5218291781992448' || machineId == "5251620728209408") { // TL,TR, TS
        newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
      }

      if (machineId == "166046" || machineId == "73017") { // TL,TR, rechts links
        newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
        newSetting.values[2] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
      }
      if (machineToUpdate) {
        machineToUpdate.execute = newSetting.execute;
        machineToUpdate.sensor = newSetting.sensor;
        machineToUpdate.values = newSetting.values;
        machineToUpdate.remark = this.machinesRemarks[machineId];
      } else {
        // add the setting object
        newSetting.machineId = machineId;
        newSetting.remark = '';
        newSetting.studioId = this.fit20.studio.id;
        this.selectedMember.machinesSettings.push(newSetting);
      }
    },
    saveMemberMachineSetting: async function (machineId, directSave, saveSession) {
      if (saveSession) {

        Object.keys(this.machinesRemarks).forEach(machineId => {
          let machineToUpdate = this.selectedMember.machinesSettings.find(machine => machine.machineId == machineId && machine.studioId == this.fit20.studio.id);
          if (machineToUpdate) {

            // machineToUpdate.remark = this.machinesRemarks[machineId];
            this.updateMemberMachineSetting(machineId);
          } else {

            this.selectedMember.machinesSettings.push({
              machineId: machineId,
              remark: this.machinesRemarks[machineId],
              endCalibration: 200,
              startCalibration: 0,
              studioId: this.fit20.studio.id,
              values: ['', '', '', '', ''],
              execute: this.executeMachine[machineId],
              sensor: this.machineSetting[String(machineId)][5].image == 'sensor-green' ? true : false,
            })
          }
        })
      }
      if (!saveSession) {
        this.updateMemberMachineSetting(machineId);
        // let machineToUpdate = this.selectedMember.machinesSettings.find(machine => machine.machineId == machineId && this.fit20.studio.id == machine.studioId);
        // let newSetting = {};
        // newSetting.values = ['', '', '', '', ''];
        // newSetting.execute = this.executeMachine[machineId];
        // newSetting.sensor = this.machineSetting[String(machineId)][5].image == 'sensor-green' ? true : false;
        // newSetting.startCalibration = machineToUpdate && machineToUpdate.startCalibration ? machineToUpdate.startCalibration : '';
        // newSetting.endCalibration = machineToUpdate && machineToUpdate.endCalibration ? machineToUpdate.endCalibration : '';
        // if (machineId == '3001') { // chest press
        //   newSetting.values[0] = this.machineSetting[String(machineId)][2].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
        //   newSetting.values[2] = this.machineSetting[String(machineId)][0].image.includes('^') ? 0 : 1;
        //   newSetting.values[3] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
        //   newSetting.values[4] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
        // }
        // if (machineId == '5001') { // latpull
        //   newSetting.values[0] = this.machineSetting[String(machineId)][1].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][0].value;
        // }
        // if (machineId == '1001') { // leg press
        //   newSetting.values[0] = this.machineSetting[String(machineId)][2].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
        // }
        // if (machineId == '4001') { //abdominal
        //   newSetting.values[0] = this.machineSetting[String(machineId)][1].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
        // }
        // if (machineId == '1002') { // back extinction
        //   newSetting.values[0] = this.machineSetting[String(machineId)][1].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][0].value;
        //   newSetting.values[2] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
        //   newSetting.values[3] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
        // }
        // if (machineId == '4002') { // adduction
        //   newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
        //   newSetting.values[2] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
        // }
        // if (machineId == '2002') { // abduction
        //   newSetting.values[0] = this.machineSetting[String(machineId)][4].image.includes('^') ? 0 : 1;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
        // }
        // if (machineId == '5872645769789440') { // mid row
        //   newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
        // }
        // if (machineId == '5002') { // RC
        //   newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
        // }
        // if (machineId == '707003' || machineId == '712001' || machineId == '725087' || machineId == '5218291781992448' || machineId == "5251620728209408") { // TL,TR, TS
        //   newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
        // }

        // if (machineId == "166046" || machineId == "73017") { // TL,TR, rechts links
        //   newSetting.values[0] = this.machineSetting[String(machineId)][0].value;
        //   newSetting.values[1] = this.machineSetting[String(machineId)][1].value;
        //   newSetting.values[2] = this.machineSetting[String(machineId)][3].image.includes('^') ? 0 : 1;
        // }
        // if (machineToUpdate) {
        //   machineToUpdate.execute = newSetting.execute;
        //   machineToUpdate.sensor = newSetting.sensor;
        //   machineToUpdate.values = newSetting.values;
        //   machineToUpdate.remark = this.machinesRemarks[machineId];
        // } else {
        //   // add the setting object
        //   newSetting.machineId = machineId;
        //   newSetting.remark = '';
        //   newSetting.studioId = this.fit20.studio.id;
        //   this.selectedMember.machinesSettings.push(newSetting);
        // }
      }

      if (!directSave) {
        this.fit20.isLoaded = false;
      }
      this.isChanged = false;
      this.showEditMachineSetting = false;
      let updateMember = await fetch(this.fit20.baseUrl + "/api/members/machineSetting/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.selectedMember),
      });
      let result = await updateMember.json();
      if (result.msg) {
        if (result.msg == "invalid-token") {
          this.clearLocalStorage();
        }

        //this.selectedMember.machinesSettings = JSON.parse(JSON.stringify(result.machinesSettings));
        // this.fit20.isLoaded = true;
        //alert(this.$t(result.msg));
        this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t(result.msg) });
      } else {
        this.originalMember.machinesSettings = JSON.parse(JSON.stringify(result.machinesSettings));
        this.newMachineRemark = '';
        // this.fit20.isLoaded = true;
      }
      if (!directSave) {
        this.selectedMachine = false;
        this.fit20.isLoaded = true;
      }
    },
    displayAllSessions: function () {
      this.displayedSessions = this.sessions;
    },
    saveSession: async function () {
      this.fit20.isLoaded = false;
      this.fit20.errors.push("Start save session for " + this.selectedMember.displayFirstName + ' ' + formattedDateTime());
      try {

        if (this.isExerciseSelected) {
          this.fit20.errors.push("save session for " + this.selectedMember.displayFirstName + ' exercise was selected ' + formattedDateTime());
          await this.unselectExercise(true);
          console.log('after unselect ');
        }
        this.fit20.errors.push("(Before saveMemberMachineSetting) save session for " + this.selectedMember.displayFirstName + ' exercise was selected ' + formattedDateTime());
        await this.saveMemberMachineSetting('', '', true);
        this.fit20.errors.push("(After  saveMemberMachineSetting) save session for " + this.selectedMember.displayFirstName + ' exercise was selected ' + formattedDateTime());
        //console.log('after saveMemberMachineSetting');
        // calc the TQS before save if it is no calculated 
        let overAllQS = 0;
        this.fit20.errors.push("before getOverAllQs saveSession in Session.vue " + formattedDateTime());
        this.fit20.errors.push(JSON.stringify(this.newSession) + " line 1494 " + formattedDateTime());
        if (this.fit20.studio.sensor && this.newSession && this.newSession.exercises && this.newSession.exercises.length > 2 && (this.newSession.training_age.overall_qs || this.newSession.training_age.overall_qs == "") && (!this.newSession.training_age.overall_qs.qs_average || this.newSession.training_age.overall_qs.qs_average == 0)) {
          overAllQS = getOverAllQs(this.newSession.exercises, true);
          if (overAllQS != 0) {
            this.newSession.training_age.overall_qs = overAllQS;
          }
        }

        let session = JSON.parse(JSON.stringify(this.newSession));
        session.exercises.forEach(exe => {
          if (exe.order && exe.order == "-") {
            if (exe.duration && exe.duration > 15) {
              exe.order = session.exercises.length;
            }
          }
        })
        session.exercises = session.exercises.filter(exe => exe.order != "-");
        if (this.newSessionRemark.length > 0) {
          session.remark = this.newSessionRemark;
        }

        session.member = this.member.id;

        if (this.selectedMember.gender.includes("male") &&
          session.exercises.length >= 4) {
          if (!session.training_age.train_at_level) {
            session.training_age.train_at_level = getTrainingAge(this.fit20.durationTable,
              this.fit20.qsTable,
              this.fit20.weightedTable,
              this.fit20.trainingAgeTable[this.selectedMember.gender],
              [session],
              this.fit20.QSType,
              this.fit20.studioMachines,
              this.fit20.minAgeExercise);
          } else {
            session.training_age.train_at_level = session.training_age.train_at_level + 0.1
          }
        }
        // console.log(session);
        if (session.id == 'new_session') {
          session.id = false;
        }
        let updateSession = await fetch(this.fit20.baseUrl + "/api/sessions/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(session),
        });

        let updatedSession = await updateSession.json();

        if (updatedSession.msg) {
          if (updatedSession.msg == "invalid-token") {
            this.clearLocalStorage();
          }

          this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t(updatedSession.msg) });
        } else {
          if (updatedSession.id) {
            // make or update the member report
            if (this.sessions && this.sessions.length >= 5) {
              fetch(this.fit20.baseUrl + `/api/members/member-report/${this.fit20.user.email}` + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.selectedMember),
              });
            }
          }
          if (!session.id && updatedSession.id) {
            this.displayedSessions.unshift(updatedSession);
            this.sessions.unshift(updatedSession);
            if (this.displayedSessions && this.displayedSessions.length >= 2) {
              if (this.displayedSessions[0].id === this.displayedSessions[1].id) {
                this.displayedSessions.shift();
              }
            }
            if (this.sessions && this.sessions.length >= 2) {
              if (this.sessions[0].id === this.sessions[1].id) {
                this.sessions.shift();
              }
            }
          } else if (session.id && updatedSession.id) {
            let sessionToUpdate = this.displayedSessions.find(session => session.id == updatedSession.id);
            let sessionToUpdate2 = this.sessions.find(session => session.id == updatedSession.id);
            if (sessionToUpdate) {
              Object.keys(sessionToUpdate).forEach(key => {
                sessionToUpdate[key] = updatedSession[key];
              })
            }
            if (sessionToUpdate2) {
              Object.keys(sessionToUpdate2).forEach(key => {
                sessionToUpdate2[key] = updatedSession[key];
              })
            }
          }
          let tempSessions = JSON.parse(localStorage.getItem(this.fit20.studio.id)) || [];
          if (tempSessions.length > 0) {
            let targetedIndex = tempSessions.findIndex(
              session => session.member == this.newSession.member
            );

            if (targetedIndex !== -1) {
              // update existing session
              tempSessions.splice(targetedIndex, 1);
            }
            // after actions on close reset the 
            localStorage.setItem(
              this.fit20.studio.id,
              JSON.stringify(tempSessions)
            );
          }
          this.newSession = {};
        }
        //this.newSession = {};
        $('[class^="machine-"]').removeClass('unselected');
        this.fit20.tabs['tab' + (this.tabNum + 2)]['action'] = '';

        this.fit20.isLoaded = true;
        // reset the temp session 
        // localStorage.setItem("studioId", false);
      } catch (err) {
        this.fit20.isLoaded = true;
        console.log({ err });
        this.fit20.errors.push("Error in saveSession in Session.vue " + formattedDateTime());
        this.fit20.errors.push(JSON.stringify({
          message: err.message,
          stack: err.stack,
          name: err.name,
        }) + " " + formattedDateTime());
        this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
      }
    },
    setSelectedMemberMachineSetting: function () {
      Object.keys(this.machinesRemarks).forEach(machineId => {
        let machineToUpdate = this.selectedMember.machinesSettings.find(machine => machine.machineId == machineId && machine.studioId == this.fit20.studio.id);
        if (machineToUpdate) {
          this.updateMemberMachineSetting(machineId);
        } else {
          this.selectedMember.machinesSettings.push({
            machineId: machineId,
            remark: this.machinesRemarks[machineId],
            endCalibration: 200,
            startCalibration: 0,
            studioId: this.fit20.studio.id,
            values: ['', '', '', '', ''],
            execute: this.executeMachine[machineId],
            sensor: this.machineSetting[String(machineId)][5].image == 'sensor-green' ? true : false,
          })
        }
      })
    },
  },
  mounted: function () {
    const container = document.getElementById('scroll_' + this.selectedMember.id);

    let beforeHeight;

    let vm = this;
    container.addEventListener('scroll', function () {
      const content = document.getElementById('scrollContent_' + vm.selectedMember.id);
      if (content) {
        const scrollTop = container.scrollTop;
        if (!beforeHeight) {
          const element = document.querySelector(`#scrollContent_${vm.selectedMember.id}`); // Adjust the selector as needed
          const computedStyle = window.getComputedStyle(element, '::before');
          beforeHeight = computedStyle.getPropertyValue('--before-height');
        }
        content.style.setProperty('--before-height', (parseInt(beforeHeight) - scrollTop) + 'px');
      }
    });
  },
  created: async function () {
    try {
      this.fit20.isLoaded = false;
      let sessionNum = 1;
      let sessionsData = await fetch(this.fit20.baseUrl + '/api/sessions/' + this.member.id + '/Member' + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
      let result = await sessionsData.json();
      if (result.msg && result.msg == "invalid-token") {
        this.clearLocalStorage();
        //alert(this.$t(result.msg));
        this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t(result.msg) });
      } else {
        this.sessions = result;
        if (this.sessions.msg) {
          this.sessions = [];
          this.fit20.isLoaded = true;
        } else {
          this.sessions = this.sessions.sort((a, b) => new Date(b.date) - new Date(a.date));
          this.displayedSessions = this.sessions.slice(0, 6);
          this.fit20.isLoaded = true;
          sessionNum = this.sessions.length + 1;
        }
      }


      // build new session :
      let currentStudio = this.member.studios.find(studio => studio.id == this.fit20.studio.id);
      let sessionPartners = [];
      currentStudio.partners.forEach(partner => sessionPartners.push(partner.id))
      this.defaultSession = {
        absent: false,
        absentReason: "",
        date: new Date().toISOString(),
        exercises: [],
        number: sessionNum,
        member: this.member.id,
        // lastModified:   handel this in the backend
        // parent:   handel this in the backend
        partners: sessionPartners,
        remark: '',
        studio: this.fit20.studio.id,
        trainer: { id: this.fit20.user.id, initials: this.fit20.user.initials },
        training_age: {
          age_group_level: '',
          best_contributor: '',
          control_age: '',
          coordination_age: '',
          overall_qs: '',
          train_at_level: '',
          younger_since_start: '',
        }
      }
    } catch (err) {
      console.log({ err });
      this.fit20.errors.push("Error in created in Session.vue " + formattedDateTime());
      this.fit20.errors.push(JSON.stringify({
        message: err.message,
        stack: err.stack,
        name: err.name,
      }) + " " + formattedDateTime());
      this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
    }
  },
  computed: {
    currentTab() {
      // Dynamically access the tab based on `tabNum`
      return this.fit20.tabs['tab' + (this.tabNum + 2)];
    }
  },
  watch: {
    'member': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        if (newVal && this.selectedMember && newVal.photo != this.selectedMember.photo) {
          this.selectedMember.photo = newVal.photo;
          return;
        }
        if (!this.alreadyOpened || this.alreadyOpened === (this.tabNum + 1)) {
          this.selectedMember = JSON.parse(JSON.stringify(newVal));
          this.selectedMember.birthDate = this.formatDate(this.selectedMember.birthDate);
          this.selectedMember.measure = this.selectedMember.measure.reverse();
          if (this.selectedMember.measure.length > 0) {
            this.selectedMember.measure[0].date = this.formatDate(this.selectedMember.measure[0].date);
          } else {
            this.selectedMember.measure = [{
              date: "",
              weight: ""
            }]
          }
          let currentStudio = this.selectedMember.studios.find(studio => studio.id == this.fit20.studio.id);
          this.selectedMember.status = JSON.parse(JSON.stringify(currentStudio.memberStatus));

          if (this.selectedMember.startMembership) {
            this.selectedMember.startMembership = this.formatDate(this.selectedMember.startMembership);
          }
          if (this.selectedMember.endMembership) {
            this.selectedMember.endMembership = this.formatDate(this.selectedMember.endMembership);
          }
          // sort the member remarks 
          this.selectedMember.remarks = this.selectedMember.remarks.sort((a, b) => {
            // Sort by 'pined' property in descending order
            if (b.pin - a.pin !== 0) {
              return b.pin - a.pin;
            }
            // If 'pined' is the same, sort by 'date' property in descending order
            return new Date(b.date) - new Date(a.date);
          });
          this.newRemarks = JSON.parse(JSON.stringify(this.selectedMember.remarks));
          this.setMachineSetting(this.selectedMember.machinesSettings);
          this.lastWeight = newVal.measure.length > 0 ? newVal.measure[newVal.measure.length - 1].weight : 0;
          this.originalMember = JSON.parse(JSON.stringify(this.selectedMember));
        }

      }
    },
    selectedMember: {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        console.log('selected member wacher')
        if (!this.alreadyOpened || this.alreadyOpened === this.tabNum) {
          if (isEqual(newVal, this.originalMember)) {
            this.isChanged = false;
          } else {
            if (!this.isChanged) {
              this.isChanged = true;
              console.log("original member changed");
            }
          }
        }

      }
    },
    'selectedMember.height': {
      handler(newVal) {
        if (!this.alreadyOpened || this.alreadyOpened === this.tabNum) {
          if (typeof newVal == 'string') {
            const numericValue = Number(newVal);
            if (!isNaN(numericValue)) {
              this.selectedMember.height = numericValue;
            } else {
              //alert(this.$t('height-validation'));
              this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('height-validation') });
            }
          }
        }
        this.alreadyOpened = JSON.parse(JSON.stringify(this.tabNum));
      }
    },
    'executeMachine': {
      handler(newVal) {
        this.isChanged = true;
      }

    },
    machineSetting: {
      handler(newVal) {
        this.isChanged = true;
      }
    },
    currentTab: {
      deep: true, // Watch for changes in nested properties
      async handler(newVal) {
        this.fit20.errors.push(newVal['active'] + "  saveSession in Session.vue line 1574 " + formattedDateTime());
        this.fit20.errors.push(newVal['action'] + "  saveSession in Session.vue line 1575 " + formattedDateTime());
        // console.log(newVal);
        if (!newVal['active']) {
          await this.unselectExercise(true);
          await this.saveMemberMachineSetting('', '', true);

          this.selectedMachine = false;
          this.activeSession = false;
          this.selectedExercise = {};
        }

        if (!newVal['active'] && newVal['action'] != 'save') {
          let tempSessions = JSON.parse(localStorage.getItem(this.fit20.studio.id)) || [];
          if (tempSessions.length > 0) {
            let targetedIndex = tempSessions.findIndex(
              session => session.member == this.newSession.member
            );

            if (targetedIndex !== -1) {
              // update existing session
              tempSessions.splice(targetedIndex, 1);
            }
            // after actions on close reset the 
            localStorage.setItem(
              this.fit20.studio.id,
              JSON.stringify(tempSessions)
            );
          }
          //console.log(JSON.parse(localStorage.getItem(this.fit20.studio)));
          if (newVal['action'] == 'cancel') {
            this.newSession = {};
          }

        }
        if (newVal['active']) {
          this.activeSession = true;
          if (newVal['action'] == 'new session') {
            this.lastExercise = false;
            // need to be tested if we have a session in the same day 
            if (this.displayedSessions.length && (new Intl.DateTimeFormat('en-US').format(new Date(this.displayedSessions[0].date)) === new Intl.DateTimeFormat('en-US').format(new Date(this.defaultSession.date)))) {
              this.editSession(this.displayedSessions[0]);
              this.setSelectedMemberMachineSetting();
              // await this.saveMemberMachineSetting('', '', true);
            } else {
              this.editSession(this.defaultSession);
              this.setSelectedMemberMachineSetting();
              console.log('new session');
              // await this.saveMemberMachineSetting('', '', true);
            }
          }
          if (newVal['action'].includes('exercise started')) {
            if (this.selectedExercise.machineId && this.isExerciseSelected) {
              if (this.closeWebSocketTimeout) {
                clearTimeout(this.closeWebSocketTimeout);
                this.closeWebSocketTimeout = false;
              }
              this.counter = -4;
              this.countDown = 4;
              this.fit20.exercisesControl['tab' + (this.tabNum + 2)].push('active exercise');
              this.fit20.saveSessionControl['tab' + (this.tabNum + 2)].push('active exercise');
              if (this.socket) {
                let machineInStudio = this.fit20.studio.machines.find(machine => machine.id == this.selectedMachine.id || this.selectedMachine.id == '1001' && machine.id == this.fit20.newLegPress);
                if (machineInStudio) {
                  try {
                    const controller = new AbortController();
                    const timeoutId = setTimeout(() => controller.abort(), 6000);
                    await fetch(`${this.fit20.hostProtocol}${machineInStudio.ipAddress}:${this.fit20.MSA_port}/exercise/start`, { method: 'GET', signal: controller.signal, });
                    clearTimeout(timeoutId);
                  } catch (err) {
                    console.log({ err });
                    this.fit20.errors.push("Error in start exe req in Session.vue in watch fit20.tabs" + formattedDateTime());
                    this.fit20.errors.push(JSON.stringify({
                      message: err.message,
                      stack: err.stack,
                      name: err.name,
                    }) + " " + formattedDateTime());
                    this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('Network error!') });
                  }
                }

              }
              this.startTime = Date.now();
              this.startCounter();
              this.exerciseIntervalId = setInterval(() => this.startCounter(), 1000); // 1000 milliseconds = 1 second
            }
          }

        }
        if (newVal['action'] == 'save') {
          // console.log(this.newSession);
          console.log('should start save');
          this.fit20.errors.push("should start save in Session.vue in watch fit20.tabs" + formattedDateTime());
          this.fit20.errors.push("The new session ID in Session.vue in watch fit20.tabs " + this.newSession.id + " " + formattedDateTime());
          if (this.newSession && this.newSession.id && ((this.newSession && this.newSession.exercises && this.newSession.exercises.length > 0) || this.newSession.absent)) {
            console.log('start save');
            this.fit20.errors.push("start save in Session.vue in watch fit20.tabs" + formattedDateTime());
            this.saveSession();
          } else {
            this.newSession = {};
          }
        }
      }
    },
    lastWeight(newVal) {
      if (!this.alreadyOpened || this.alreadyOpened === this.tabNum) {
        if (typeof newVal == 'string') {
          const numericValue = Number(newVal);
          if (!isNaN(numericValue)) {
            this.lastWeight = numericValue;
            this.newWeight.weight = numericValue;
            if (this.newWeight.weight != 0 && (this.originalMember.measure.length == 0 || this.newWeight.weight != this.originalMember.measure[0].weight)) {
              if (!this.isChanged) {
                this.isChanged = true;
              }
            } else {
              this.isChanged = false;
            }
          } else {
            // alert(this.$t('weight-validation'));
            this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('weight-validation') });
          }
        }
      }
    }
  }
};
</script>

<style>
.popup-countDown {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 150px;
  height: 150px;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent box */
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  border-radius: 50%;
  /* optional, just to make it look nice */
}

.session-studio-container {
  display: flex;
  position: relative;
  padding: 5px;
  width: 100%;
  height: 700px;
}

.multi-members {
  height: 400px;
}

.inactive {
  display: none;
}



.session-r {
  width: 0%;
}

.session-r-active {
  width: 28%;
}

.session-m {
  padding: 0 10px;
  width: 72%;
  height: 100%;
  direction: rtl;
  flex-wrap: nowrap;
  display: flex;
}

.session-m-active {
  width: 44%;
}

.border {
  border: solid 1px var(--fit20-blue);
}


.dropdown-options {
  z-index: 9999999999999999;
}


.machine-setting-sec1 {
  text-align: right;
  position: relative;
}

.machine-setting-sec1 .machine-img {
  width: 59px;
  border: solid 1px var(--fit20-blue);
  border-radius: 5px;
  padding: 3px;
}

.machine-setting-sec1 span {
  position: absolute;
  top: 40px;
  right: 70px;
  color: var(--fit20-blue);
}

.machine-setting-sec2 {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
  flex-wrap: wrap;
  height: 80px;
}

.machine-setting-sec2 .machine-settings-active {
  width: calc(100% / 3);
  position: relative;
  height: 40px;
  text-align: center;
  margin-top: 5px;
}

.machine-setting-sec2 .machine-settings-active img {
  height: 35px;
}

.machine-setting-sec2 .machine-settings-active span {
  position: absolute;
  right: 50%;
}

.machine-setting-sec3,
.machine-setting-sec5 {
  margin: 15px 10px 5px 10px;
  font-size: 10px;
  border: solid 1px var(--fit20-lighter-gray);
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  height: 50px;
  overflow-y: scroll;

}

.machine-setting-sec3 div,
.machine-setting-sec5 div {
  min-width: 57%;
  padding-left: 10px;
  max-width: 95%;
  outline: none;
  min-height: 45px;
}

.machine-remark-title {
  padding-top: 5px;
}

.session-remarks-sec {
  text-align: left !important;
  direction: ltr !important;
  position: relative;
}

.session-remarks-sec>div {
  position: absolute;
  top: 0px;
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 5px;
  z-index: 2;
  width: 130px;
  height: 55px;
  overflow-y: scroll;
  padding: 5px;
}

.session-remarks-sec div:focus {
  outline: none;
}

.session-remark-title {
  padding-top: 5px;
  flex-direction: row;
}

.machine-setting-sec4 {
  justify-content: space-around;
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}


.machine-setting-time-sec {
  color: var(--fit20-blue);
}

.machine-setting-time {
  padding: 7px 5px 5px 5px;
  border: solid 1px var(--fit20-blue);
  border-radius: 5px;
}

.machine-setting-time-colin {
  padding: 0 5px 10px 5px;
}

.machine-setting-weight {
  color: black;
  padding: 7px 5px;
  border: solid 1px black;
  border-radius: 5px;
}

.machine-setting-sec4 .dropdown-option {
  font-size: 14px;
}

.machine-setting-sec6 {
  width: 100%;
  justify-content: space-between;
  padding: 0 10px;
}

.machine-setting-sec6 div {
  width: 25%;
  margin: auto;
  text-align: center;
}

.machine-setting-sec6 div img {
  width: 85%;
  height: 85%;
  max-width: 51px;
}

.new-session {
  z-index: 2 !important;
  /* right: 140px; */
  overflow: auto;
  position: relative;
}

.new-session::before {
  content: '';
  position: absolute;
  display: inline-block;
  width: 58px;
  height: var(--before-height);
  background-color: var(--fit20-lighter-blue) !important;
  z-index: -10;
  left: 0;
  top: 5px;
  border-radius: 10px;
  -webkit-transform: translateZ(0);
}

.selected-machine {
  border: solid 2px var(--fit20-green);
  border-radius: 7px;
  overflow: hidden;
  background-color: var(--fit20-lighter-blue);
}

.selected-machine-finish {
  border: solid 2px #b8b8b8;
  border-radius: 7px;
  overflow: hidden !important;
}

.order {
  background-color: var(--fit20-lighter-gray);
  border-radius: 7px;
  overflow: hidden;
}

.countDown {
  width: 150px;
  height: 150px;
  font-size: 70px;
  border-radius: 50% !important;
  color: white;
  background-color: var(--fit20-blue);
  text-align: center;
  padding: 25%;
}
</style>
